import React, { useEffect, useState } from "react";
import '../../../../assets/css/valuelist.css';
import MainWrapper from "../../../MainWrapper";
import { Link, Navigate } from "react-router-dom";
import Icon from "react-icons-kit";
import { ic_arrow_back, ic_mode_edit, ic_save } from 'react-icons-kit/md';
import { Table, Form, InputGroup } from 'react-bootstrap';
import { connect } from 'react-redux';
import Create from "./models/CreateSalesStage";
import ConfirmDelete from "./models/ConfirmDelete";
// import { encrypted } from '../../../../_utils/helpers';
import {
	REGION_REQUEST,
	REGION_CREATE,
	REGION_DELETE,
	REGION_EDIT,
	REGION_STATE_CHANGE
} from "../../../../_utils/constants/ValueList";
import Loader from "../../../layouts/Loader";
import { toast } from 'react-toastify';

const Region = ({
	auth: { auth, isAuthenticated },
	valueList: { valueList, isCreated, isDeleted, isEdited, isLoading },
	fetchRegions,
	submitRegionCreate,
	submitRegionDelete,
	submitRegionEdit,
	changeReducerState
}) => {

	// states declarations
	const [createModalOpen, setCreateModalOpen] = useState(false);
	const [regionName, setRegionName] = useState('');
	const [sortOrder, setSortOrder] = useState("");
	const [confirmDeleteModal, setConfirmDeleteModal] = useState(false);
	const [deleteRegionId, setDeleteRegionId] = useState('');
	const [editRegionId, setEditRegionId] = useState('');
	const [editRegionName, setEditRegionName] = useState('');
	const [editSortOrder, setEditSortOrder] = useState('');

	// use effect function called for authentication
	useEffect(() => {
		if (isAuthenticated) {
			fetchRegions(auth[0].token);
		}
	}, [auth, isAuthenticated]);

	// use effect function called after api success
	useEffect(() => {
		if (isCreated === true) {
			toast.success("Region Created Successfully.");
			fetchRegions(auth[0].token);
			changeReducerState();
		}
		if (isDeleted === true) {
			toast.success("Region Deleted Successfully.");
			fetchRegions(auth[0].token);
			changeReducerState();
		}
		if (isEdited === true) {
			toast.success("Region Data Updated Successfully.");
			fetchRegions(auth[0].token);
			changeReducerState();
		}
	}, [isCreated, isDeleted, isEdited]);

	// function to open create modal
	const showCreateModal = () => {
		setCreateModalOpen(true);
	};

	// function to close create modal
	const hideCreateModal = () => {
		setCreateModalOpen(false);
	};

	// function called for input value change of create modal
	const handleRegionNameChange = (e) => {
		setRegionName(e.target.value);
	}
	const handleSortOrderChange = (e) => {
		setSortOrder(e.target.value);
	}

	// function called for create Region create api
	const handleCreateModalSubmit = (e) => {
		e.preventDefault();
		if (regionName === '') {
			toast.error("Region name cannot be empty.");
		} else {
			submitRegionCreate({
				"data": {
					"Region": regionName,
					"Sort": parseInt(sortOrder),
					"CreatedBy": auth[0].userId
				},
				"token": auth[0].token
			});
			hideCreateModal();
		}
	}

	// function to open confirm delete modal
	const showConfirmDeleteModal = (id) => {
		setDeleteRegionId(id);
		setConfirmDeleteModal(true);
	};

	// function to close confirm delete modal
	const hideConfirmDeleteModal = () => {
		setDeleteRegionId('');
		setConfirmDeleteModal(false);
	};

	// function called for delete Region delete api
	const handleConfirmDeleteSubmit = () => {
		submitRegionDelete({
			"regionId": deleteRegionId,
			"token": auth[0].token
		});
		hideConfirmDeleteModal();
	}

	// function called on edit icon click
	const handleEditClick = (data) => {
		setEditRegionId(data.regionId);
		setEditRegionName(data.region);
		setEditSortOrder(data.sort);
	}

	// function called to save edited data
	const handleEditSaveClick = (data) => {
		if (editRegionName === '') {
			toast.error("Region name cannot be empty.");
		} else {
			submitRegionEdit({
				"data": {
					"RegionId": data.regionId,
					"Region": editRegionName,
					"Sort": editSortOrder
				},
				"token": auth[0].token
			});
			setEditRegionId('');
			setEditRegionName('');
			setEditSortOrder('');
		}
	}

	if (!isAuthenticated) return <Navigate to="/login" />;

	return (
		<MainWrapper>
			<Loader loading={isLoading}>
				<div className="container">

					<div className="sub-header mt-5 mb-3">
						<h2>Regions</h2>
						<Link className="btn btn-primary me-1" to="/admin"><Icon icon={ic_arrow_back} />Back to Value List</Link>
						<Create
							variant="primary"
							title={`Region`}
							createModalOpen={createModalOpen}
							showCreateModal={showCreateModal}
							hideCreateModal={hideCreateModal}
							salesStageName={regionName}
							handleSalesStageNameChange={handleRegionNameChange}
							sortOrder={sortOrder}
							handleSortOrderChange={handleSortOrderChange}
							handleCreateModalSubmit={handleCreateModalSubmit}
						/>
					</div>
					<Table responsive bordered>
						<thead>
							<tr>
								<th>Regions</th>
								<th className="text-center">Sort Order</th>
								<th width="50" className="actions">
									<div className="d-flex">
										<span>Edit</span>
										<span>Delete</span>
									</div>
								</th>
							</tr>
						</thead>
						<tbody>
							{valueList && valueList.length > 0 ? (
								valueList.map((item, index) => (
									editRegionId === item.regionId ? (
										<tr key={index}>
											<td>
												<Form.Group>
													<InputGroup>
														<Form.Control type="text" value={editRegionName} onChange={(evt) => setEditRegionName(evt.target.value)} />
													</InputGroup>
												</Form.Group>
											</td>
											<td width="150">
												<Form.Group>
													<InputGroup>
														<Form.Control type="text" value={editSortOrder} onChange={(evt) => setEditSortOrder(evt.target.value)} />
													</InputGroup>
												</Form.Group>
											</td>
											<td className="actions">
												<div className="btn-group">
													<Icon role="button" className="mt-2 w-54 d-flex justify-content-center" size={24} icon={ic_save} onClick={() => handleEditSaveClick(item)} />
													<ConfirmDelete variant="primary" title={`Region`} showConfirmDeleteModal={() => showConfirmDeleteModal(item.regionId)} hideConfirmDeleteModal={hideConfirmDeleteModal} handleConfirmDeleteSubmit={handleConfirmDeleteSubmit} confirmDeleteModal={confirmDeleteModal} />
												</div>
											</td>
										</tr>
									) : (
										<tr key={index}>
											<td>
												{item.region}
											</td>
											<td width="150">
												{item.sort}
											</td>
											<td className="actions">
												<div className="btn-group">
													<Icon role="button" className="mt-2 w-54 d-flex justify-content-center" size={24} icon={ic_mode_edit} onClick={() => handleEditClick(item)} />
													<ConfirmDelete variant="primary" title={`Region`} showConfirmDeleteModal={() => showConfirmDeleteModal(item.regionId)} hideConfirmDeleteModal={hideConfirmDeleteModal} handleConfirmDeleteSubmit={handleConfirmDeleteSubmit} confirmDeleteModal={confirmDeleteModal} />
												</div>
											</td>
										</tr>
									)
								))
							) : (
								<tr>
									<td colSpan={4}>
										No Data Found.
									</td>
								</tr>
							)}
						</tbody>
					</Table>
				</div>
			</Loader>
		</MainWrapper>
	)
}

const mapStateToProps = ({ auth, valueList }) => {
	return {
		auth,
		valueList
	};
};
const mapDispatchToProps = (dispatch) => {
	return {
		fetchRegions: (token) => dispatch({ type: REGION_REQUEST, token }),
		submitRegionCreate: (data) => dispatch({ type: REGION_CREATE, payload: data }),
		submitRegionDelete: (data) => dispatch({ type: REGION_DELETE, payload: data }),
		submitRegionEdit: (data) => dispatch({ type: REGION_EDIT, payload: data }),
		changeReducerState: () => dispatch({ type: REGION_STATE_CHANGE })
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(Region);